<template>
  <div class="back-button">
    <a href="" @click.prevent="handleClick">
      <span class="material-icons inline-block align-middle mr-2"
        >arrow_back</span
      >
      <span>Back</span>
    </a>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  props: ["url"],
  setup(props) {
    const router = useRouter();
    const handleClick = () => {
      if (props.url) {
        router.push(props.url);
      } else {
        router.back();
      }
    };
    return {
      handleClick,
    };
  },
};
</script>
